import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import { Tabs, ScrollAnimationParent, ModalWithTransition } from '@studiometa/ui';
import HeroScroll from './HeroScroll.js';
import AccordionSkeepers from './AccordionSkeepers.js';
import Slider from './Slider/index.js';
import SliderAuto from './SliderAuto/index.js';
import ProductLastViewed from './ProductLastViewed.js';
import TopBar from './TopBar.js';
import Newsletter from './Newsletter.js';
import ScrollVideo from './ScrollVideo/index.js';
import StickyHeader from './StickyHeader.js';
import FillingText from './FillingText/index.js';
import Uneo from './Uneo.js';
import HeroCore from './HeroCore.js';
import ScrollingList from './ScrollingList.js';
import ScrollingEventail from './ScrollingEventail/index.js';
import ReassuranceScroll from './ReassuranceScroll.js';
import NoiseReduction from './NoiseReduction.js';
import VideoModal from './VideoModal.js';
import DocumentationSearch from './DocumentationSearch/index.js';

/**
 * Sections component
 */
export default class Sections extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Sections',
    components: {
      AccordionSkeepers,
      ScrollAnimationParent,
      HeroScroll,
      Tabs,
      Slider,
      SliderAuto,
      ProductLastViewed,
      TopBar,
      Newsletter,
      ScrollVideo,
      StickyHeader,
      ModalWithTransition,
      VideoModal,
      DocumentationSearch,
      Uneo,
      FillingText,
      HeroCore,
      ReassuranceScroll,
      PerformanceCircle: (app) =>
        importWhenVisible(() => import('./PerformanceCircle.js'), 'PerformanceCircle', app, {
          threshold: 0.7,
        }),
      ScrollingList,
      CollapseBackground: (app) =>
        importWhenVisible(() => import('./CollapseBackground.js'), 'CollapseBackground', app),
      ScrollingPerformance: (app) =>
        importWhenVisible(() => import('./ScrollingPerformance.js'), 'ScrollingPerformance', app),
      Soundwave: (app) =>
        importWhenVisible(() => import('./Soundwave.js'), 'Soundwave', app, { treshold: 0.5 }),
      ScrollingEventail,
      NoiseReduction,
      ModelViewer: (app) =>
        importWhenVisible(() => import('./ModelViewer.js'), 'ModelViewer', app, { threshold: 0.1 }),
      Sav: (app) => importWhenVisible(() => import('./Sav.js'), 'Sav', app),
      VideoLinks: (app) => importWhenVisible(() => import('./VideoLinks.js'), 'VideoLinks', app),
      Stories: (app) => importWhenVisible(() => import('./Stories/index.js'), 'Stories', app),
      CollectionLinks: (app) =>
        importWhenVisible(() => import('./CollectionLinks.js'), 'CollectionLinks', app),
      Accordion: (app) => importWhenVisible(() => import('./Accordion/index.js'), 'Accordion', app),
      Map: (app) => importWhenVisible(() => import('./Map.js'), 'Map', app),
      YotpoReviews: (app) =>
        importWhenVisible(() => import('./YotpoReviews.js'), 'YotpoReviews', app),
      HeroCoreP6: (app) => importWhenVisible(() => import('./HeroCoreP6.js'), 'HeroCoreP6', app),
      WebglDetails: (app) =>
        importWhenVisible(() => import('./WebglDetails.js'), 'WebglDetails', app),
      ScrollingWebgl: (app) =>
        importWhenVisible(() => import('./ScrollingWebgl.js'), 'ScrollingWebgl', app),
      WebglTechnology: (app) =>
        importWhenVisible(() => import('./WebglTechnology.js'), 'WebglTechnology', app),
    },
  };
}
